module.exports = __webpack_public_path__ + "img/plus-circle.66dad209.svg";